var _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueCircleMailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "#323755"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail",
    transform: "translate(7 -76.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    transform: "translate(0 85.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M11.878,85.333H.642A.644.644,0,0,0,0,85.975v7.063a.644.644,0,0,0,.642.642H11.878a.644.644,0,0,0,.642-.642V85.975A.644.644,0,0,0,11.878,85.333Zm-.241.482L6.63,89.571a.671.671,0,0,1-.739,0L.883,85.815Zm-2.675,4,2.729,3.371.009.009H.82l.009-.009,2.729-3.371a.241.241,0,0,0-.374-.3l-2.7,3.338V86.116L5.6,89.956a1.149,1.149,0,0,0,1.316,0l5.121-3.84v6.738l-2.7-3.338a.241.241,0,0,0-.374.3Z",
    transform: "translate(0 -85.333)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCircleMailIcon);
export default __webpack_public_path__ + "static/media/BlueCircleMailIcon.5fc76b47.svg";
export { ForwardRef as ReactComponent };